<template>
  <div class="tab-item">
    <div class="tab-item-heading" @click="selectTab(name)">
      <div class="tab-item-heading-title"> <strong>{{ name }}</strong></div>

      <span class="selection" v-if="selection"><small>

        <span class="selection-item" v-for="(selectindex, select) in selection" :key="selectindex.hash" :data-cat="select">

                 {{ (Array.isArray(selectindex.value) ? selectindex.value.join(", ") : selectindex.value )}}
        </span>



      </small></span>
      <span class="selection" v-else><small>beliebig</small></span>
    </div>
    <div v-show="(selected === name)" class="tab-item-content">
      <div class="tab-item-content-modal">
        <span class="close-tab-item-modal"  @click="hideTab(name)">+</span>
        <h3>{{ name }}</h3>
      <slot></slot>

        <div class="button__group  mt__60">
        <button type="button" class="button button__rounded button__primary" @click="hideTab(name)">{{ count }} Ergebnisse anzeigen</button>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabItem",

  props: {
    name: {required: true},
    selected: {default: false},
    selection: {default: false },
    count: {default: 0 }
  },
  methods: {
    selectTab(tab) {
      if(tab === "Leasing"){
        this.$emit("update-financing", tab);
      }

      this.$emit("update-tab", tab);
    },
    hideTab(tab) {
      this.$emit("hide-tab", tab);
    }
  }
}
</script>

<style scoped lang="scss">

.tab-item{
}

.close-tab-item-modal{
  position: absolute;
  top: 0;
  right: 0;
  padding: 20px;
  display: block;
  cursor: pointer;
  font-size: 1.4rem;
  transform: rotate(
          45deg
  );

}

.tab-item-heading{
  cursor: pointer;
}
.tab-item-content{
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  height: 100%;
  background: rgba(0,0,0,0.3);
  z-index: 9999999;

  display: grid;
  margin: auto;
  grid-template-columns: repeat(24, 1fr);
  grid-template-areas:
        "a1 a1 a1 a1 a1 a1 a0 a0 a0 a0 a0 a0 a0 a0 a0 a0 a0 a0 a2 a2 a2 a2 a2 a2";
  align-content: center;
  align-items: center;



  .tab-item-content-modal{
    border-radius: 5px;

    max-height: 90vh;
    overflow: auto;
    background: #fff;
    position: relative;
    padding: 30px 45px;
    grid-area: a0;
  }


}

.selection-item{
  display: inline-block;
  padding: 4px 8px;
  border-radius: 25px;
  background: #efefef;
  margin-right: 6px;
  margin-top: 6px;
}


</style>